import { render, staticRenderFns } from "./landing-page.html?vue&type=template&id=77ca7c68&scoped=true&"
import script from "./landing-page.js?vue&type=script&lang=js&"
export * from "./landing-page.js?vue&type=script&lang=js&"
import style0 from "./landing-page.scss?vue&type=style&index=0&id=77ca7c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ca7c68",
  null
  
)

export default component.exports